/* eslint-disable @typescript-eslint/no-explicit-any */
import CONSTANTS from '../constants/constants';
import jsonnetConfigService from '../services/jsonnetConfigService';
import getJsonnetData from '../utils/getJsonnetData';
import { TradeInIntegrationType } from '../enums/tradeInIntegrationType';
const { APP_CONFIG_BASE_URL } = CONSTANTS;
const jsonnetApi = {
    getConfiguration: async ({ brand, region, country, language, }) => {
        try {
            const response = await (await getJsonnetData(APP_CONFIG_BASE_URL, brand, region, country, language)).json();
            const { platformFeatures } = response;
            if (!platformFeatures) {
                throw new Error('Missing feature flags platform configuration.');
            }
            const paymentProviderKey = Object.values(response.payment || {}).pop();
            return {
                paymentProvider: paymentProviderKey?.provider,
                priceDisplay: jsonnetConfigService.fromJsonnet(response?.priceDisplay),
                tradeInIntegration: TradeInIntegrationType.NONE,
                platformFeatures: response.platformFeatures,
                financeCalculator: jsonnetConfigService.transformFinanceCalculator(response.financeCalculator),
                oauth: response.oauth,
                myAccount: response.myAccount,
                salesEnablement: response.salesEnablement,
                checkout: response.checkout30,
                spcDealersFileName: paymentProviderKey?.spcDealersFileName,
                isVariantsPageEnabled: paymentProviderKey?.variantsPage === true,
                isFuelFilteringEnabled: paymentProviderKey?.fuelFilter === true,
                isBodyStyleFilteringEnabled: paymentProviderKey?.bodyStyleFilter === true,
                isTransmissionFilteringEnabled: paymentProviderKey?.transmissionFilter === true,
                isPriceSortingEnabled: paymentProviderKey?.carPriceSorting === true,
                isDealerSelectionEnabled: paymentProviderKey?.dealerSelectionIntegration === true,
                isSaveOfferEnabled: paymentProviderKey?.saveOffer === true,
                isFinanceEnabled: paymentProviderKey?.financeIntegration === true,
                isCheckoutLiteEnabled: paymentProviderKey?.spcCheckoutLiteIntegration === true,
                showGovernmentCharges: paymentProviderKey?.showGovernmentCharges === true,
                hideSubmitWhenNoStock: paymentProviderKey?.hideSubmitWhenNoStock === true,
                isComplexModel: paymentProviderKey?.complexModel === true,
                gqlApi: paymentProviderKey?.gqlApi === true,
                stockPage: paymentProviderKey?.stock,
                catalogTrimFeatures: paymentProviderKey?.catalogTrimFeatures,
                engineTrimFeatures: paymentProviderKey?.engineTrimFeatures,
                isCheckout3Enabled: paymentProviderKey?.isCheckout3Enabled === true,
                showThreeSixtyImages: paymentProviderKey?.showThreeSixtyImages,
                isStockLiteEnabled: paymentProviderKey?.isStockLiteEnabled,
            };
        }
        catch (e) {
            throw new Error('Unable to get platform configuration.');
        }
    },
};
export default jsonnetApi;
//# sourceMappingURL=jsonnetApi.js.map